import { makeStyles } from '@material-ui/core';

export const useStyles = ({ backgroundColor }: { backgroundColor?: string }) =>
  makeStyles(({ spacing }) => ({
    imageWrapper: {
      backgroundColor,
    },
    title: {
      marginBottom: spacing(0.5),
    },
    description: {
      marginBottom: spacing(2),
    },
  }));

export default {
  useStyles,
};
